<template>
  <v-app>
    <main-menu
      v-if="isAuthorized"
      class="d-print-none"
    />

    <!-- main content -->
    <v-main>
      <v-container
        fluid
        class="pa-0 fill-height"
      >
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import MainMenu from './components/System/Layout/MainMenu'

export default {
  name: 'App',

  components: {
    MainMenu
  },

  data () {
    return {
      showNavigation: true,
      mini: true
    }
  },

  computed: {
    ...mapGetters('auth', [
      'isAuthorized',
      'getAccessToken'
    ])
  },

  created () {
    // Set locale
    this.setLocale(this.$i18n.locale)

    // check response status & logout on 401
    axios.interceptors.response.use(
      undefined,
      err => {
        return new Promise(() => {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch('auth/logout')
              .finally(() => this.$router.push({ path: '/login' }))
          }

          throw err
        })
      }
    )
  }
};
</script>

<style lang="scss">
html {
  font-size: 18px;
  overflow-y: auto
}

.theme--light.v-application {
  color: #302030 !important;
}

.page {
  padding: 30px;
  //background-color: #f7f8fa;
  width: 100%;
  height: 100%;
  border-top-left-radius: 30px;
}

@media print {
  .v-main {
    padding: 0 !important;
  }
}
</style>
